import messages from './messages';
import { EMAIL_REGULAR_EXPRESSION } from '../../../utils/common/constants';

const emailRegex = EMAIL_REGULAR_EXPRESSION;

export default (values,
  { formatMessage },
) => {
  const errors = {};

  if (!values.email) {
    errors.emailError = formatMessage(messages.emptyEmailError);
  }

  if (values.email
    && !emailRegex.test(values.email)) {
    errors.emailError = formatMessage(messages.emailFormatError);
  }

  return errors;
};
